import { useQuery } from "react-query";
import { getVendorOfficesById } from "../../../../actions/CarrierAgreementMgmt/Vendor";

const useGetVendorOffices = (searchInputsData) => {
  return useQuery(
    ["GetVendorOffices"],
    () => getVendorOfficesById(searchInputsData),
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetVendorOffices;
